import React, { FC, useEffect, useState } from 'react';

import { auth, authLocalPersistence } from '../firebase';
import ZotaLoader from '../components/shared/ZotaLoader';

interface ContextValues {
  isSignedIn: boolean;
}

const defaultContextValues: ContextValues = {
  isSignedIn: false,
};

const AnonymousAuthContext = React.createContext<ContextValues>(defaultContextValues);

export const AnonymousAuthContextProvider: FC = ({ children }) => {
  const [state, setState] = useState<ContextValues>(defaultContextValues);

  useEffect(() => {
    return auth.onAuthStateChanged(async (user) => {
      await auth.setPersistence(authLocalPersistence);

      if (user) {
        setState({ isSignedIn: true });
      } else {
        try {
          await auth.signInAnonymously();

          setState({ isSignedIn: true });
        } catch (err) {
          setState({ isSignedIn: false });
        }
      }
    });
  }, []);

  if (!state.isSignedIn) {
    return (
      <ZotaLoader/>
    );
  }

  return (
    <AnonymousAuthContext.Provider value={state}>
      {children}
    </AnonymousAuthContext.Provider>
  );
};
